import { render, staticRenderFns } from "./DialogEditMedio.vue?vue&type=template&id=b623bd1a&scoped=true"
import script from "./DialogEditMedio.vue?vue&type=script&lang=js"
export * from "./DialogEditMedio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b623bd1a",
  null
  
)

export default component.exports